module.exports = __webpack_public_path__ + "img/76014.79fb9c78.svg";